import React, { Component } from "react"
import styled from "styled-components"
import { TINY_SHADOW } from "./consts/colors"
import Fade from "react-reveal/Fade"

const SectionImageWrapper = styled.div`
  img {
    display: flex;
    position: relative;
    width: ${props => props.ImgWidth};
    top: ${props => props.positionTB};
    left: ${props => props.positionLR};
    margin: 0px 25px;
    border-radius: 8px;
    box-shadow: ${props =>
      props.shadow
        ? "0px 4px 10px rgba(90, 88, 94, 0.3);"
        : "0px 0px 0px rgba(90, 88, 94, 0.3);"};
    @media screen and (max-width: 768px) {
      position: relative;
      justify-content: center;
    }
  }
`

const SectionImage = ({
  show,
  shadow,
  ImgWidth,
  positionTB,
  positionLR,
  src
}) => {
  return (
    <SectionImageWrapper
      shadow={shadow}
      ImgWidth={ImgWidth}
      positionTB={positionTB}
      positionLR={positionLR}>
      <img src={src} />
    </SectionImageWrapper>
  )
}

export default SectionImage



// WEBPACK FOOTER //
// ./src/components/SectionImage.js